
import React, { useState, useEffect } from 'react'
import Modal from '@/Components/Modal/Modal'
import useTranslation from '@/Hooks/UseTranslation'
import { exportDashboardToExcel } from '@/Services/web/DashboardService'
import FileDownloader from './FileDownloader'

interface Props {
  show: boolean
  title: string
  file: string
  exportData: any
  onHide: () => void
}

const ModalExporter = ({ show, title, file, exportData, onHide }: Props) => {

  const { t } = useTranslation()

  const [ loading, setLoading ] = useState(true)
  const [ fileName, setFileName ] = useState('')
  const [ fileUrl, setFileUrl ] = useState('');
  const [ error, setError ] = useState('');

  useEffect(() => {

    const exportFile = async () => {

      if (!file || !exportData) return

      setError('')

      let service = null

      switch(file) {
        case 'dashboard-excel': {

          setFileName('dashboard-excel.xlsx')

          service = exportDashboardToExcel
        }
      }

      if (!service) return

      try {


        const { data: { fileUrl }} = await service(exportData)

        setLoading(false);

        setFileUrl(fileUrl)

      } catch (error) {

        setLoading(false);

        if (error instanceof Error) {

          setError(error.message)
        }
      }
    }

    if (show && file && exportData) {

      exportFile()
    }
  }, [show, file, exportData])

  return (
    <Modal
      show={show}
      title={title}
      onClose={onHide}
      backdropClassName='modal-exporter-backdrop'
      className='modal-exporter'
      showCloseButton={!!fileUrl}
    >
      {loading && (
        <div className="spinner spinner-primary"></div>
      )}
      {!loading && fileUrl && (
        <FileDownloader
          fileUrl={fileUrl}
          fileName={fileName}
          btnLabel={t('MODAL_EXPORTER:DownloadExcelFileButton')}
        />
      )}
      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}
    </Modal>
  )
}

export default ModalExporter
